// nc-video.js
// Handles Vimeo autoplay, play button overlay, and volume control

(function() {
  'use strict';
  
  function initVimeoVideos() {
    var videoSections = document.querySelectorAll('.video__container');
    
    videoSections.forEach(function(container) {
      var vimeoFrame = container.querySelector('iframe.vimeo-player');
      var playBtn = container.querySelector('.video-play-btn');
      
      if (!vimeoFrame || !playBtn) return;

      playBtn.addEventListener('click', function() {
        // Get current iframe src
        var currentSrc = vimeoFrame.src;
        
        // Remove muted parameter and ensure autoplay is enabled
        var newSrc = currentSrc.replace('muted=1', 'muted=0');
        
        // Reload iframe with unmuted audio
        vimeoFrame.src = newSrc;
        
        // Hide play button
        playBtn.style.display = 'none';
      });
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVimeoVideos);
  } else {
    initVimeoVideos();
  }
})();
